// extracted by mini-css-extract-plugin
export default {"modal":"BimWorkOrderSubObjectEdit_modal__ZC4cX"};